<nav class="navbar">

  <!-- Logo -->
  <a routerLink="/" class="navbar-brand" [attr.aria-label]="sistemaNombre() + ': ir al inicio'">
    <app-marca-logo class="navbar-brand__logo" [alto]="34" [anchoMax]="170" />
    <span class="navbar-brand__name">{{ sistemaNombre() }}</span>
  </a>

  <!-- Acciones derecha -->
  <div class="navbar-actions">

    <!-- ── Campana de notificaciones ─────────────────────────── -->
    <!-- Reúne los comunicados del módulo antiguo (/api/notificaciones) y los avisos nuevos (/api/avisos); cada uno se marca por su propia ruta. -->
    <div class="notif-menu" [class.notif-menu--open]="notifOpen()" (keydown.escape)="alPulsarEscape($event)" (focusout)="alPerderElFoco($event)">

      <button
        #campana
        class="notif-btn"
        (click)="toggleNotif()"
        type="button"
        pRipple
        [attr.aria-label]="etiquetaCampana()"
        [attr.aria-expanded]="notifOpen()"
        aria-haspopup="dialog"
        aria-controls="panel-notificaciones"
        data-testid="campana"
      >
        <span class="pi pi-bell notif-btn__icon" aria-hidden="true"></span>
      </button>
      @if (noLeidas() > 0) {
        <!-- El número ya va en el nombre del botón: el globo es solo para los ojos. -->
        <span class="notif-badge" [class.notif-badge--urgente]="hayUrgentes()" aria-hidden="true" data-testid="campana-globo">
          @if (hayUrgentes()) { <span class="pi pi-exclamation-triangle notif-badge__ico"></span> }
          {{ globoTexto() }}
        </span>
      }
      <!-- Región educada: dice cuántas hay sin leer cuando el número cambia. -->
      <div class="sr-solo" aria-live="polite" aria-atomic="true" data-testid="campana-anuncio">{{ anuncio() }}</div>

      <!-- Dropdown de notificaciones -->
      @if (notifOpen()) {
        <div #panelNotif class="notif-dropdown" id="panel-notificaciones" role="dialog" aria-label="Notificaciones" tabindex="-1" data-testid="panel-notificaciones">

          <!-- Header -->
          <div class="notif-dropdown__header">
            <span class="notif-dropdown__title">Notificaciones</span>
            @if (noLeidas() > 0) {
              <span class="notif-dropdown__count">{{ globoTexto() }} sin leer</span>
            }
            @if (noLeidas() > 0) {
              <button class="notif-dropdown__read-all" type="button" (click)="marcarTodasLeidas()">
                Marcar todas leídas
              </button>
            }
          </div>

          <div class="notif-cuerpo">

            @if (avisos.errorAccion(); as mensaje) {
              <p class="notif-error-accion" role="alert" data-testid="panel-error-accion">
                <span class="pi pi-exclamation-circle" aria-hidden="true"></span>
                <span>{{ mensaje }}</span>
              </p>
            }

            <!-- Avisos nuevos -->
            @if (avisos.panelEstado() === 'error' && avisosPanel().length === 0) {
              <section class="notif-bloque" aria-labelledby="notif-t-avisos">
                <h3 class="notif-bloque__titulo" id="notif-t-avisos">Avisos</h3>
                <div class="notif-estado notif-estado--error" role="alert" data-testid="panel-error">
                  <span class="pi pi-exclamation-circle" aria-hidden="true"></span>
                  <span class="notif-estado__txt">{{ avisos.panelError() }}</span>
                  <button class="notif-estado__btn" type="button" (click)="reintentarPanel()">Reintentar</button>
                </div>
              </section>
            } @else if (avisosPanel().length > 0) {
              <section class="notif-bloque" aria-labelledby="notif-t-avisos">
                <h3 class="notif-bloque__titulo" id="notif-t-avisos">Avisos</h3>
                <ul class="notif-list notif-list--avisos" role="list">
                  @for (a of avisosPanel(); track a.id) {
                    <li
                      class="aviso-item aviso-item--{{ a.severidad }}"
                      [class.aviso-item--leida]="a.estado !== 'nueva'"
                      [attr.data-aviso]="a.id"
                      data-testid="aviso-item"
                    >
                      <div class="notif-item__strip" aria-hidden="true"></div>
                      @if (conDestino(a)) {
                        <button type="button" class="aviso-item__abrir" (click)="abrirAviso(a)" data-testid="aviso-abrir">
                          <ng-container *ngTemplateOutlet="contenidoAviso; context: { $implicit: a }" />
                        </button>
                      } @else {
                        <div class="aviso-item__abrir aviso-item__abrir--sin" data-testid="aviso-sin-destino">
                          <ng-container *ngTemplateOutlet="contenidoAviso; context: { $implicit: a }" />
                        </div>
                      }
                      <div class="aviso-item__acciones">
                        @if (a.estado === 'nueva') {
                          <button type="button" class="aviso-item__btn" (click)="leerAviso(a, $event)"
                            [attr.aria-label]="'Marcar como leída: ' + a.titulo" title="Marcar como leída" data-testid="aviso-leer">
                            <span class="pi pi-check" aria-hidden="true"></span>
                          </button>
                        }
                        <button type="button" class="aviso-item__btn" (click)="archivarAviso(a, $event)"
                          [attr.aria-label]="'Archivar: ' + a.titulo" title="Archivar" data-testid="aviso-archivar">
                          <span class="pi pi-inbox" aria-hidden="true"></span>
                        </button>
                      </div>
                    </li>
                  }
                </ul>
              </section>
            } @else if (avisos.panelEstado() === 'cargando') {
              <div class="notif-estado" role="status" data-testid="panel-cargando">
                <span class="pi pi-spin pi-spinner" aria-hidden="true"></span>
                <span class="notif-estado__txt">Cargando tus avisos…</span>
              </div>
            }

            <!-- Comunicados del portal (módulo antiguo) -->
            @if (notificaciones().length > 0) {
              <section class="notif-bloque" aria-labelledby="notif-t-comunicados">
                <h3 class="notif-bloque__titulo" id="notif-t-comunicados">Comunicados</h3>
                <ul class="notif-list" role="list">
                  @for (n of notificaciones(); track n.id) {
                    <li
                      class="notif-item notif-item--{{ n.tipo }}"
                      [class.notif-item--leida]="n.leida"
                      [class.notif-item--fijada]="n.fijada"
                    >
                      <div class="notif-item__strip"></div>

                      <div class="notif-item__body">
                        <div class="notif-item__head">
                          <span class="notif-item__icon pi {{ iconoPorTipo(n.tipo) }}"></span>
                          <span class="notif-item__titulo">{{ n.titulo }}</span>
                          @if (n.fijada) {
                            <span class="notif-item__pin pi pi-thumbtack" title="Fijada"></span>
                          }
                          @if (!n.leida) {
                            <span class="notif-item__dot" aria-label="No leída"></span>
                          }
                        </div>

                        <p class="notif-item__msg">{{ n.mensaje }}</p>

                        <div class="notif-item__meta">
                          <span class="notif-item__time">{{ tiempoRelativo(n.fecha) }}</span>
                          <div class="notif-item__actions">
                            @if (n.accion) {
                              <button
                                class="notif-item__btn-accion"
                                type="button"
                                (click)="irAccion(n.accion.ruta)"
                              >
                                {{ n.accion.label }}
                              </button>
                            }
                            @if (!n.leida) {
                              <button
                                class="notif-item__btn-read"
                                type="button"
                                (click)="marcarLeida(n.id, $event)"
                                title="Marcar como leída"
                              >
                                <span class="pi pi-check"></span>
                              </button>
                            }
                            <button
                              class="notif-item__btn-del"
                              type="button"
                              (click)="eliminarNotif(n.id, $event)"
                              title="Eliminar"
                            >
                              <span class="pi pi-times"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </li>
                  }
                </ul>
              </section>
            }

            <!-- Sin nada que mostrar -->
            @if (notificaciones().length === 0 && avisosPanel().length === 0 && avisos.panelEstado() !== 'cargando' && avisos.panelEstado() !== 'error') {
              <ul class="notif-list" role="list">
                <li class="notif-empty" data-testid="panel-vacio">
                  <span class="pi pi-check-circle"></span>
                  <span>Sin notificaciones</span>
                  <span class="notif-empty__ayuda">Aquí te avisaremos de lo que necesite tu atención, como un traspaso por autorizar o algo por vencer.</span>
                </li>
              </ul>
            }
          </div>

          <div class="notif-dropdown__pie">
            <a class="notif-dropdown__ver-todas" routerLink="/notificaciones" (click)="cerrarNotif()" data-testid="ver-todas">
              Ver todas
              <span class="pi pi-arrow-right" aria-hidden="true"></span>
            </a>
          </div>

        </div>
      }
    </div>

    <!-- ── Botón avatar con dropdown ──────────────────────────── -->
    <div class="user-menu" [class.user-menu--open]="menuOpen()">

      <button class="user-btn" (click)="toggleMenu()" type="button" pRipple>
        @if (userAvatarUrl() && !avatarCargaError()) {
          <p-avatar [image]="userAvatarUrl()!" shape="circle" styleClass="user-btn__avatar" (onImageError)="avatarCargaError.set(true)" />
        } @else {
          <p-avatar [label]="userInitials()" shape="circle" styleClass="user-btn__avatar" />
        }
        <span class="user-btn__name">
          {{ currentUser()?.nombre ?? 'Usuario' }}
        </span>
        <span class="user-btn__chevron pi pi-chevron-down"></span>
      </button>

      <!-- Dropdown -->
      @if (menuOpen()) {
        <div class="user-dropdown">
          <div class="user-dropdown__header">
            @if (userAvatarUrl() && !avatarCargaError()) {
              <p-avatar [image]="userAvatarUrl()!" shape="circle" styleClass="user-dropdown__avatar" (onImageError)="avatarCargaError.set(true)" />
            } @else {
              <p-avatar [label]="userInitials()" shape="circle" styleClass="user-dropdown__avatar" />
            }
            <div class="user-dropdown__info">
              <span class="user-dropdown__name">{{ currentUser()?.nombre ?? 'Usuario' }}</span>
              <span class="user-dropdown__email">{{ currentUser()?.correo ?? '' }}</span>
            </div>
          </div>

          <div class="user-dropdown__divider"></div>

          <ul class="user-dropdown__menu">
            <li>
              <button type="button" (click)="goToProfile()" pRipple data-mi-cuenta>
                <span class="pi pi-user"></span>
                Mi cuenta
              </button>
            </li>
            <li>
              <button type="button" (click)="goToTickets()" pRipple data-mis-tickets>
                <span class="pi pi-list-check"></span>
                Mis tickets
              </button>
            </li>
          </ul>

          <div class="user-dropdown__divider"></div>

          <ul class="user-dropdown__menu">
            <li class="user-dropdown__menu--danger">
              <button type="button" (click)="logout()" pRipple>
                <span class="pi pi-sign-out"></span>
                Cerrar sesión
              </button>
            </li>
          </ul>
        </div>
      }

    </div>
  </div>

</nav>

<!-- El contenido de un aviso del panel: lo comparten el botón (con pantalla a la que ir) y el bloque sin destino. Todo el texto va escapado (interpolación), nunca como HTML. -->
<ng-template #contenidoAviso let-a>
  <span class="aviso-item__fila">
    <span class="pi aviso-item__icono {{ iconoAviso(a) }}" aria-hidden="true"></span>
    @if (a.severidad === 'urgente') {
      <span class="aviso-item__urgente" data-testid="aviso-urgente">Urgente</span>
    }
    @if (a.estado === 'nueva') {
      <span class="aviso-item__punto" aria-hidden="true"></span>
      <span class="sr-solo">Sin leer.</span>
    }
  </span>
  <span class="aviso-item__titulo">{{ a.titulo }}</span>
  <span class="aviso-item__texto">{{ a.texto }}</span>
  <span class="aviso-item__tiempo">{{ tiempoAviso(a) }}</span>
</ng-template>
